import { useLazyQuery } from "@apollo/client/react";
import { useCallback, useEffect, useState } from "react";
import { GET_PACIENTE_CONTRATOS } from "../../../data/graphQL/queries/BuscarPaciente/getBuscarPacienteDetalle";

export const useGetRows = (idPaciente) => {
  const [rows, setRows] = useState([]);

  const [getBuscarPacienteDetalle, { loading: buscarPacienteLoading, data: pacienteContratosData }] = useLazyQuery(GET_PACIENTE_CONTRATOS, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (pacienteContratosData) {
      const contratos = pacienteContratosData.pacienteContratos?.valorEsperado || [];
      setRows(contratos);
    }
  }, [pacienteContratosData]);

  const handleSearch = useCallback(() => {
    getBuscarPacienteDetalle({ variables: { idPaciente } });
  }, [idPaciente, getBuscarPacienteDetalle]);

  return {
    rows,
    setRows,
    loading: buscarPacienteLoading,
    totalCount: rows?.length || 0,
    handleSearch
  };
};